// Detect mobile device
(function(a) {
  (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))
})(navigator.userAgent || navigator.vendor || window.opera);

// Check if the browser is IE or Edge...
var uA = window.navigator.userAgent,
  onlyIEorEdge = /msie\s|trident\/|edge\//i.test(uA) && !!(document.uniqueID || window.MSInputMethodContext),
  checkVersion = (onlyIEorEdge && +(/(edge\/|rv:|msie\s)([\d.]+)/i.exec(uA)[2])) || NaN,
  result = document.getElementById('resultado');

document.getElementById('detalles').innerHTML = uA;

result.innerHTML = !isNaN(checkVersion) ? 'You\'re using ' + (checkVersion >= 12 ? 'Microsoft Edge ' : 'Windows Internet Explorer ') + checkVersion : 'You\'re not using Microsoft\'s Browser.';

// EXAMPLE
// if ($.browser.mobile) {
//   // Mobile things
// } else {
//   // Desktop things
// }

// End detect mobile device

// Stop video jumping
// console.log(result.innerHTML);

$(document).ready(function() {
  if ($.browser.mobile || result.innerHTML !== "You're not using Microsoft's Browser.") {
    // console.log("IE");
    $(".video_inner").css("position", "inherit");
    $("video").css("position", "inherit");
    $(".home_page_wrapper .top_banner_wrapper:nth-child(2n) .banner_image").css("position", "inherit");
    $(".home_page_wrapper .top_banner_wrapper:nth-child(2n) .banner_image").css("background-attachment", "inherit");
    $(".how_can_we_help_you_banner").css("position", "inherit");
    $(".how_can_we_help_you_banner").css("background-attachment", "inherit");
    $(".angle_bottom").css("display", "none");
  } else {
    // console.log("Chrome");
    $(".video_inner").css("position", "fixed");
    $("video").css("position", "fixed");
    $("#jarallax-container-0 div").css("position", "fixed");
  }
});





$(document).ready(function() {
  $(this).scrollTop(0);
});

$(document).ready(function() {
  $("input, textarea, select").each(function() {
    $(this).attr('data-lpignore', 'true');
  });
});

// Home page bubbles
$('.moveup').hover(function() {
  // TweenMax.killTweensOf($(".explore_button"));
  TweenMax.to($(".moveup h3"), 0.3, {
    y: -5,
    ease: Power1.easeInOut
  });
}, function() {
  // TweenMax.killTweensOf($(".explore_button"));
  TweenMax.to($(".moveup h3"), 0.3, {
    y: 0,
    ease: Power1.easeInOut
  });
});

$('.title_wrap_inner').hover(function() {
  // TweenMax.killTweensOf($(".explore_button"));
  TweenMax.to($(this).find("h3"), 0.3, { // Add tweenmax.
    y: -5,
    ease: Power1.easeInOut
  });
}, function() {
  // TweenMax.killTweensOf($(".explore_button"));
  TweenMax.to($(this).find("h3"), 0.3, { // Add tweenmax.
    y: 0,
    ease: Power1.easeInOut
  });
});

// Home Page Scroll to Arrow
$('.arrow_down').hover(function() {
  TweenMax.to($(".cls-1"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    fill: '#af0008'
  });
}, function() { // This acts like a roll off state.
  TweenMax.to($(".cls-1"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    fill: '#c2272e'
  });
});

$(".arrow_down").on("click", function() {
  goToByScroll(".top_of_page", 0, 1);
});

// Footer Buttons
$('.social_btn').hover(function() {
  TweenMax.to($(this).find(".social-1"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    fill: '#af0008'
  });
  TweenMax.to($(this).find(".social-2"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    fill: '#fff'
  });
}, function() { // This acts like a roll off state.
  TweenMax.to($(this).find(".social-1"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    fill: '#fff'
  });
  TweenMax.to($(this).find(".social-2"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    fill: '#c2272e'
  });
});

// Top Navigation
$('.top_sub_nav ul li a').hover(function() {
  TweenMax.to($(this).prev(), 0.5, { // Add tweenmax.
    autoAlpha: 1.0,
    ease: Power2.easeInOut
  });
}, function() { // This acts like a roll off state.
  TweenMax.to($(this).prev(), 0.5, { // Add tweenmax.
    autoAlpha: 0.0,
    ease: Power2.easeInOut
  });
});

// Banner Go to by Scroll
$(".bottom_arrow").on("click", function() {
  goToByScroll(".go_top", 0, 0.5);
});

// Home page bubbles
var height_to_store = $(".banner_1 .banner_name_bubble").height();
$('.banner_name_bubble').hover(function() {
  TweenMax.killTweensOf($(".explore_button"));
  TweenMax.killTweensOf($(".hidden_description"));
  TweenMax.killTweensOf($(".h3"));
  TweenMax.to($(this), 0.5, {
    height: "350px",
    ease: Power1.easeInOut
  });
  TweenMax.to($(this).find("h3"), 0.5, {
    y: 20,
    ease: Power1.easeInOut
  });
  TweenMax.to($(this).find(".hidden_description"), 0.5, {
    autoAlpha: 1.0,
    y: 60,
    ease: Power1.easeInOut,
  });
  TweenMax.to($(this).find(".explore_button"), 0.2, {
    autoAlpha: 1.0,
    delay: 0.3,
    ease: Power1.easeInOut
  });
}, function() { // This acts like a roll off state.
  TweenMax.killTweensOf($(".explore_button"));
  TweenMax.killTweensOf($(".hidden_description"));
  TweenMax.killTweensOf($(".h3"));
  TweenMax.to($(this), 0.5, {
    height: height_to_store + "px",
    ease: Power1.easeInOut
  });
  TweenMax.to($(this).find("h3"), 0.5, {
    y: 50,
    ease: Power1.easeInOut
  });
  TweenMax.to($(this).find(".hidden_description"), 0.5, {
    autoAlpha: 0.0,
    y: 200,
    ease: Power1.easeInOut
  });
  TweenMax.to($(this).find(".explore_button"), 0.1, {
    autoAlpha: 0.0,
    ease: Power1.easeInOut
  });
});

// Scroll ins
$(window).scroll(function() {
  $('.top_banner_wrapper').each(function() {

    var x_value_to_set;
    var bottom_of_object = $(this).offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if ($(this).hasClass("odd_scroll_in")) {
      x_value_to_set = "-1600";
    } else {
      x_value_to_set = "1600";
    }

    if (bottom_of_window > bottom_of_object) {
      TweenMax.to($(this).find(".banner_name_bubble"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
      });
      TweenMax.to($(this).find(".banner_name_bubble h3"), 0.6, {
        autoAlpha: 1.0,
        y: 50,
        ease: Power1.easeInOut
      });
    } else {
      TweenMax.to($(this).find(".banner_name_bubble"), 0.5, {
        autoAlpha: 0.0,
        x: x_value_to_set
      });
      TweenMax.to($(this).find(".banner_name_bubble h3"), 0.6, {
        autoAlpha: 0.0,
        y: 101,
        ease: Power1.easeInOut
      });
    }
  });
});


if ($("body").hasClass("home")) {

  $(window).scroll(function() {
    var x_value_to_set;
    var bottom_of_object = $(".our_clients_bottom_banner").offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if (bottom_of_window > bottom_of_object) {
      $(".slide_image_wrap").addClass("slideInUp")
    }
  });
}

$(window).scroll(function() {
  $('.work_with_us_banner').each(function() {

    var x_value_to_set;
    var bottom_of_object = $(this).offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if (bottom_of_window > bottom_of_object) {
      TweenMax.to($(this).find(".fadeInUp"), 0.5, {
        autoAlpha: 1.0,
        y: 0,
        ease: Power1.easeInOut
      });
      TweenMax.to($(this).find(".fadeInUp p"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
        ease: Power1.easeInOut
      });
    } else {
      TweenMax.to($(this).find(".fadeInUp"), 0.5, {
        autoAlpha: 0.0,
        y: "-30",
        ease: Power1.easeInOut
      });
      TweenMax.to($(this).find(".fadeInUp p"), 0.3, {
        autoAlpha: 0.0,
        x: "60",
        ease: Power2.easeInOut
      });
    }
  });
});


$(window).scroll(function() {
  $('.how_can_we_help_you_banner').each(function() {

    var x_value_to_set;
    var bottom_of_object = $(this).offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if (bottom_of_window > bottom_of_object) {
      TweenMax.to($(this).find(".form_wrap h2"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
        ease: Power1.easeInOut
      });
    } else {
      TweenMax.to($(this).find(".form_wrap h2"), 0.5, {
        autoAlpha: 0.0,
        x: "-30",
        ease: Power1.easeInOut
      });
    }
  });
});

// Load Team image on scroll
if (window.location.href.indexOf('about') > -1) {

  $(window).scroll(function() {
    var x_value_to_set;
    var bottom_of_object = $(".about_first_section").offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if (bottom_of_window > bottom_of_object) {
      TweenMax.to($(".about_first_section .first_left"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
        ease: Power1.easeInOut
      });
      TweenMax.to($(".about_first_section .first_left p"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
        ease: Power1.easeInOut
      });
    } else {
      TweenMax.to($(".about_first_section .first_left"), 0.5, {
        autoAlpha: 0.0,
        x: "-30",
        ease: Power1.easeInOut
      });
      TweenMax.to($(".about_first_section .first_left p"), 0.3, {
        autoAlpha: 0.0,
        x: "60",
        ease: Power2.easeInOut
      });
    }
  });

  $(window).scroll(function() {
    var x_value_to_set;
    var bottom_of_object = $(".about_second_section").offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if (bottom_of_window > bottom_of_object) {
      TweenMax.to($(".about_second_section .second_right"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
        ease: Power1.easeInOut
      });
      TweenMax.to($(".about_second_section .second_right p"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
        ease: Power1.easeInOut
      });
    } else {
      TweenMax.to($(".about_second_section .second_right"), 0.5, {
        autoAlpha: 0.0,
        x: "-30",
        ease: Power1.easeInOut
      });
      TweenMax.to($(".about_second_section .second_right p:nth-child(2)"), 0.3, {
        autoAlpha: 0.0,
        x: "-60",
        ease: Power2.easeInOut
      });
      TweenMax.to($(".about_second_section .second_right p:nth-child(2)"), 0.3, {
        autoAlpha: 0.0,
        x: "60",
        ease: Power2.easeInOut
      });
      TweenMax.to($(".about_second_section .second_right p:nth-child(3)"), 0.3, {
        autoAlpha: 0.0,
        x: "-60",
        ease: Power2.easeInOut
      });
    }
  });

  var run_stagger = false;
  var allow_hovers = false;

  // Meet the Team Staggers
  $(window).scroll(function() {
    var x_value_to_set;
    var bottom_of_object = $(".meet_the_team_wrapper").offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if (bottom_of_window > bottom_of_object) {
      if (run_stagger !== true) {
        run_stagger = true;
        setTimeout(function() {
          allow_hovers = true;
        }, 3000);
        TweenMax.staggerFrom(".third_section_team:nth-child(odd)", 2, {
          y: 30,
          opacity: 1,
          ease: Power2.easeOut,
          force3D: true
        }, 0.2);
        TweenMax.staggerFrom(".third_section_team:nth-child(even)", 2, {
          y: -30,
          opacity: 0,
          ease: Power2.easeOut,
          force3D: true
        }, 0.2);
      }
    }
  });
}


if ($("body").hasClass("single-products")) {

  $(window).scroll(function() {
    var x_value_to_set;
    var bottom_of_object = $(".single_products_page_wrapper").offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if (bottom_of_window > bottom_of_object) {
      TweenMax.to($(".first_section_content .first_left"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
        ease: Power1.easeInOut
      });
      TweenMax.to($(".first_section_content .first_left p"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
        ease: Power1.easeInOut
      });
    } else {
      TweenMax.to($(".first_section_content .first_left"), 0.5, {
        autoAlpha: 0.0,
        x: "-30",
        ease: Power1.easeInOut
      });
      TweenMax.to($(".first_section_content .first_left p"), 0.3, {
        autoAlpha: 0.0,
        x: "60",
        ease: Power2.easeInOut
      });
    }
  });
}

// if ($("body").hasClass("single-products")) {

//   $(window).scroll(function () {
//     var x_value_to_set;
//     var bottom_of_object = $(".third_section").offset().top;
//     var bottom_of_window = $(window).scrollTop() + $(window).height();

//     if (bottom_of_window > bottom_of_object) {
//       TweenMax.to($(".third_section .title_right h3"), 0.5, {
//         autoAlpha: 1.0,
//         x: 0,
//         ease: Power1.easeInOut
//       });
//     } else {
//       TweenMax.to($(".third_section .title_right h3"), 0.5, {
//         autoAlpha: 0.0,
//         x: "-30",
//         ease: Power1.easeInOut
//       });
//     }
//   });
// }

if ($("body").hasClass("single-products")) {

  $(window).scroll(function() {
    var x_value_to_set;
    var bottom_of_object = $(".product_form").offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if (bottom_of_window > bottom_of_object) {
      TweenMax.to($(".quote_title_left h3"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
        ease: Power1.easeInOut
      });
    } else {
      TweenMax.to($(".quote_title_left h3"), 0.5, {
        autoAlpha: 0.0,
        x: "30",
        ease: Power1.easeInOut
      });
    }
  });
}

if ($("body").hasClass("single-products")) {

  $(window).scroll(function() {
    var x_value_to_set;
    var bottom_of_object = $(".product_form").offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if (bottom_of_window > bottom_of_object) {
      TweenMax.to($(".form_descripstion"), 0.5, {
        autoAlpha: 1.0,
        y: 0,
        ease: Power1.easeInOut
      });
    } else {
      TweenMax.to($(".form_descripstion"), 0.5, {
        autoAlpha: 0.0,
        y: "60",
        ease: Power1.easeInOut
      });
    }
  });
}

if ($("body").hasClass("single-products")) {

  $(window).scroll(function() {
    var x_value_to_set;
    var bottom_of_object = $(".fourth_section").offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if (bottom_of_window > bottom_of_object) {
      TweenMax.to($(".title_left h3"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
        ease: Power1.easeInOut
      });
    } else {
      TweenMax.to($(".title_left h3"), 0.5, {
        autoAlpha: 0.0,
        x: "60",
        ease: Power1.easeInOut
      });
    }
  });
}


// End scroll ins

// Team Hovers
var original_src;
var swap_src;
$('.third_section_team').hover(function() {
  if (allow_hovers === true) {
    TweenMax.killTweensOf($(".third_section_team"));
    TweenMax.to($(this).find(".team_name"), 0.3, {
      opacity: 1,
      x: 0,
      ease: Power4.easeInOut
    });
    TweenMax.to($(this).find(".loves"), 0.3, {
      opacity: 1,
      x: 0,
      ease: Power4.easeInOut
    });
    // Swap the images over
    swap_src = $(this).find("img").attr("data-swap-src");
    $(this).find("img").attr("src", swap_src);
  }
}, function() {
  if (allow_hovers === true) {
    TweenMax.killTweensOf($(".third_section_team"));
    TweenMax.to($(this).find(".team_name"), 0.3, {
      opacity: 0,
      x: 45,
      ease: Power4.easeInOut
    });
    TweenMax.to($(this).find(".loves"), 0.3, {
      opacity: 0,
      x: -45,
      ease: Power4.easeInOut
    });
    // Swap back
    swap_src = $(this).find("img").attr("data-original-src");
    $(this).find("img").attr("src", swap_src);
  }
});

// Fix for "Lets Do It" form submit button on Harrisons Creative HP
$("#gform_wrapper_1 .gform_footer").appendTo("#gform_wrapper_1 #gform_fields_1");

// Scroll to top 
$(document).ready(function() {
  $(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
      $('.scrollup').fadeIn();
    } else {
      $('.scrollup').fadeOut();
    }
  });
  $('.scrollup').click(function() {
    $("html, body").animate({
      scrollTop: 0
    }, 600);
    return false;
  });
});

// Blog expandable areas
$(".row_year").on("click", function() {
  var that = this;
  $(".years_posts").css("display", "none");
  $(".row_year .icon").css("transform", "none");
  $(that).next().css("display", "block");
  TweenMax.to($(that).find(".icon"), 0.4, { // Fill the middle
    ease: Power3.easeInOut,
    rotation: 180
  });
});

$(".row_cat").on("click", function() {
  var that = this;
  $(".recent_posts").css("display", "none");
  $(".row_cat .icon").css("transform", "none");
  $(that).next().css("display", "block");
  TweenMax.to($(that).find(".icon"), 0.4, { // Fill the middle
    ease: Power3.easeInOut,
    rotation: 180
  });
});
// End blog expandable areas

// Expandable Content. Add Display none on the Elements in the CSS.
$(".expand_button").on("click", function() {
  if ($(this).hasClass("open")) {
    TweenMax.set($(this).find("svg"), {
      rotation: "0",
      ease: Power1.easeInOut
    });
    TweenMax.set($(this).find(".cls-1"), {
      ease: Power1.easeInOut,
      fill: "#c0c8d3"
    });
    TweenMax.set($(this).closest(".the_row").find(".hidden_content_wrapper"), {
      display: "none",
      padding: "0px"
    });
    $(this).removeClass("open");
  } else {
    goToByScroll($(this).parent().parent().parent(), 10, 0.5);
    TweenMax.set(".expandable_row", {
      // borderBottom: "2px solid #89C3C0"
    });
    TweenMax.set(".expand_button svg", {
      rotation: "0"
    });
    TweenMax.set(".hidden_content_wrapper", {
      display: "none",
      padding: "0px"
    });
    $(".expand_button").removeClass("open");
    $(this).addClass("open");
    TweenMax.set($(this).parent().parent().parent(), {
      borderBottom: "none"
    });
    TweenMax.set($(this).find('svg'), {
      rotation: "180",
      ease: Power1.easeInOut
    });
    TweenMax.set($(this).find(".cls-1"), {
      ease: Power1.easeInOut,
      fill: "#f68b28"
    });
    TweenMax.set($(this).parent().parent().parent().next(), {
      display: "block",
      padding: "10px 0"
    });
  }
});

$(".expandable_row h3").on("click", function() {
  $(this).closest(".the_row").find(".expand_button").trigger("click");
});

// Add-on function for Owl Carousel. Adds class to first and last slides.
function checkClasses() {
  var total = $('.owl-carousel .owl-stage .owl-item.active').length;
  $('.owl-carousel .owl-stage .owl-item').removeClass('firstActiveItem lastActiveItem');
  $('.owl-carousel .owl-stage .owl-item.active').each(function(index) {
    if (index === 0) {
      // this is the first one
      $(this).addClass('firstActiveItem');
    }
    if (index === total - 1 && total > 1) {
      // this is the last one
      $(this).addClass('lastActiveItem');
    }
  });
}

// "Work with us" carousel
$('.work_with_us_banner .arrow_right').hover(function() {
  TweenMax.to($(".work_with_us_banner .right_arrow0"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    fill: '#af0008'
  });
}, function() { // This acts like a roll off state.
  TweenMax.to($(".work_with_us_banner .right_arrow0"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    fill: '#c2272e'
  });
});



$(document).ready(function() {
  var carousel = $(".work_with_us_banner .owl-carousel");
  carousel.owlCarousel({
    loop: true,
    nav: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      767: {
        items: 3,
        autoWidth: true
      }
    },
    navText: [$('.work_with_us_banner .owl_prev_custom'), $('.work_with_us_banner .owl_next_custom')]
  });
  checkClasses();
  carousel.on('translated.owl.carousel', function(event) {
    checkClasses();
  });
});

// "Our Clients" carousel
$('.our_clients_bottom_banner .arrow_right').hover(function() {
  TweenMax.to($(".our_clients_bottom_banner .right_arrow0"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    fill: '#af0008'
  });
}, function() { // This acts like a roll off state.
  TweenMax.to($(".our_clients_bottom_banner .right_arrow0"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    fill: '#c2272e'
  });
});

setTimeout(function() {
  $(document).ready(function() {
    var clients_carousel = $(".our_clients_bottom_banner .owl-carousel");
    clients_carousel.owlCarousel({
      loop: true,
      nav: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 3,
          nav: true
        },
        767: {
          items: 6,
          nav: false
        }
      },
      navText: [$('.our_clients_bottom_banner .owl_prev_custom'), $('.our_clients_bottom_banner .owl_next_custom')]
    });
    checkClasses();
    clients_carousel.on('translated.owl.carousel', function(event) {
      checkClasses();
    });
  });
}, 300);

// Single Products

$(document).ready(function() {
  $('.single-products .header .main_logo').removeClass('center_me');
});


// Product Image Carousel

$('.first_section_content .arrow_right').hover(function() {
  TweenMax.to($(".first_section_content .right_arrow0"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    fill: '#af0008'
  });
}, function() { // This acts like a roll off state.
  TweenMax.to($(".first_section_content .right_arrow0"), 0.5, { // Add tweenmax.
    ease: Power1.easeInOut,
    fill: '#c2272e'
  });
});

// Single Product Buttons

$(document).ready(function() {
  $('.product_details_btn').addClass('product_btn_active');
});


$('.product_btn').click(function() {
  $(".product_btn").removeClass('product_btn_active');
  $(this).addClass('product_btn_active');

  $(".product_description_wrapper_inner>div").css("display", "none");

  if ($(this).hasClass("product_details_btn")) {
    $(".product_details").css("display", "block");
    TweenMax.to($(".product_details"), 0.3, {
      y: 0,
      ease: Power1.easeInOut,
      opacity: 1,
    });
  } else if ($(this).hasClass("product_specification_btn")) {
    $(".product_specification").css("display", "block");
    TweenMax.to($(".product_specification"), 0.3, {
      y: 0,
      ease: Power1.easeInOut,
      opacity: 1,
    });
  } else if ($(this).hasClass("product_faqs_btn")) {
    $(".product_faqs").css("display", "block");
    TweenMax.to($(".product_faqs"), 0.3, {
      y: 0,
      ease: Power1.easeInOut,
      opacity: 1,
    });
  } else {
    $(".product_downloads").css("display", "block");
    TweenMax.to($(".product_downloads"), 0.3, {
      y: 0,
      ease: Power1.easeInOut,
      opacity: 1,
    });
  }

  // Reset the css after the else.

  TweenMax.set($(".product_description_wrapper_inner>div"), {
    y: 50,
    opacity: 0,
  });

});

$('.product_btn').hover(function() {
  // TweenMax.killTweensOf($(".explore_button"));
  TweenMax.to($(this).find("h3"), 0.3, { // Add tweenmax.
    y: -5,
    ease: Power1.easeInOut
  });
}, function() {
  // TweenMax.killTweensOf($(".explore_button"));
  TweenMax.to($(this).find("h3"), 0.3, { // Add tweenmax.
    y: 0,
    ease: Power1.easeInOut
  });
});

$('.request_quote').hover(function() {
  // TweenMax.killTweensOf($(".explore_button"));
  TweenMax.to($(this).find("h3"), 0.3, { // Add tweenmax.
    y: -5,
    ease: Power1.easeInOut
  });
}, function() {
  // TweenMax.killTweensOf($(".explore_button"));
  TweenMax.to($(this).find("h3"), 0.3, { // Add tweenmax.
    y: 0,
    ease: Power1.easeInOut
  });
});

$('.download_wrapper_containter').hover(function() {
  // TweenMax.killTweensOf($(".explore_button"));
  TweenMax.to($(this).find(".title_block"), 0.3, { // Add tweenmax.
    y: -5,
    ease: Power1.easeInOut
  });
  TweenMax.to($(this).find(".title_block"), 0.5, { // Add tweenmax.
    background: '#dbdbdb',
    ease: Power1.easeInOut
  });
  TweenMax.to($(this).find(".download_title"), 0.5, { // Add tweenmax.
    color: '#c2272e',
    ease: Power1.easeInOut
  });
  TweenMax.to($(this).find(".pdf"), 0.5, { // Add tweenmax.
    fill: '#c2272e',
    ease: Power1.easeInOut
  });
  TweenMax.to($(this).find(".ai"), 0.5, { // Add tweenmax.
    fill: '#c2272e',
    ease: Power1.easeInOut
  });
}, function() {
  // TweenMax.killTweensOf($(".explore_button"));
  TweenMax.to($(this).find(".title_block"), 0.5, { // Add tweenmax. 
    y: 0,
    ease: Power1.easeInOut
  });
  TweenMax.to($(this).find(".title_block"), 0.5, { // Add tweenmax.
    background: '#c2272e',
    ease: Power1.easeInOut
  });
  TweenMax.to($(this).find(".download_title"), 0.5, { // Add tweenmax.
    color: '#fff',
    ease: Power1.easeInOut
  });
  TweenMax.to($(this).find(".pdf"), 0.5, { // Add tweenmax.
    fill: '#fff',
    ease: Power1.easeInOut
  });
  TweenMax.to($(this).find(".ai"), 0.5, { // Add tweenmax.
    fill: '#fff',
    ease: Power1.easeInOut
  });
});

$(document).ready(function() {
  var carousel = $(".third_section .owl-carousel");
  carousel.owlCarousel({
    loop: true,
    items: 3,
    nav: true,
    navText: [$('.third_section .owl_prev_custom'), $('.third_section .owl_next_custom')]
  });
  checkClasses();
  carousel.on('translated.owl.carousel', function(event) {
    checkClasses();
  });
});

$(".product_details").on("click", function() {
  goToByScroll(".product_form", 0, 1);
});



// $(document).ready(function () {
//   var movementStrength = 25;
//   var height = movementStrength / $(window).height();
//   var width = movementStrength / $(window).width();
//   $(".single-products .banner_image").mousemove(function (e) {
//     var pageX = e.pageX - ($(window).width() / 2);
//     var pageY = e.pageY - ($(window).height() / 2);
//     var newvalueX = width * pageX * -1 - 25;
//     var newvalueY = height * pageY * -1 - 50;
//     $('.single-products .banner_image').css("background-position", newvalueX + "px     " + newvalueY + "px");
//   });
// });



// Event branding bits
if ($("body").hasClass("page-template-page-events") || $("body").hasClass("page-template-page-exhibitions")) {

  // Scroll ins
  $(window).scroll(function() {
    $('.testimonial_item').each(function() {

      var x_value_to_set;
      var bottom_of_object = $(this).offset().top;
      var bottom_of_window = $(window).scrollTop() + $(window).height();

      if ($(this).hasClass("testimonial_item_1")) {
        x_value_to_set = "-1600";
      } else {
        x_value_to_set = "1600";
      }

      if (bottom_of_window > bottom_of_object) {
        TweenMax.to($(this), 0.5, {
          autoAlpha: 1.0,
          x: 0,
        });
      } else {
        TweenMax.to($(this), 0.5, {
          autoAlpha: 0.0,
          x: x_value_to_set
        });
      }
    });
  });

  $(window).scroll(function() {
    var x_value_to_set;

    if ($("body").hasClass("page-template-page-events")) {
      var bottom_of_object = $(".event_branding_wrapper").offset().top;
    } else if ($("body").hasClass("page-template-page-exhibitions")) {
      var bottom_of_object = $(".exhibitions_page_wrapper").offset().top;
    }

    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if (bottom_of_window > bottom_of_object) {
      TweenMax.to($(".our_ethos_section .first_left"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
        ease: Power1.easeInOut
      });
      TweenMax.to($(".our_ethos_section .first_left p"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
        ease: Power1.easeInOut
      });
    } else {
      TweenMax.to($(".our_ethos_section .first_left"), 0.5, {
        autoAlpha: 0.0,
        x: "30",
        ease: Power1.easeInOut
      });
      TweenMax.to($(".our_ethos_section .first_left p"), 0.3, {
        autoAlpha: 0.0,
        x: "-60",
        ease: Power2.easeInOut
      });
    }
  });


  $(window).scroll(function() {
    var x_value_to_set;
    var bottom_of_object = $(".what_we_do_section").offset().top;
    var bottom_of_window = $(window).scrollTop() + $(window).height();

    if (bottom_of_window > bottom_of_object) {
      TweenMax.to($(".what_we_do_section .first_right"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
        ease: Power1.easeInOut
      });
      TweenMax.to($(".what_we_do_section .first_right p"), 0.5, {
        autoAlpha: 1.0,
        x: 0,
        ease: Power1.easeInOut
      });
    } else {
      TweenMax.to($(".what_we_do_section .first_right"), 0.5, {
        autoAlpha: 0.0,
        x: "-30",
        ease: Power1.easeInOut
      });
      TweenMax.to($(".what_we_do_section .first_right p:nth-child(2)"), 0.3, {
        autoAlpha: 0.0,
        x: "-60",
        ease: Power2.easeInOut
      });
      TweenMax.to($(".what_we_do_section .first_right p:nth-child(3)"), 0.3, {
        autoAlpha: 0.0,
        x: "60",
        ease: Power2.easeInOut
      });
      TweenMax.to($(".what_we_do_section .first_right p:nth-child(4)"), 0.3, {
        autoAlpha: 0.0,
        x: "-60",
        ease: Power2.easeInOut
      });
      TweenMax.to($(".what_we_do_section .first_right p:nth-child(5)"), 0.3, {
        autoAlpha: 0.0,
        x: "60",
        ease: Power2.easeInOut
      });
      TweenMax.to($(".what_we_do_section .first_right p:nth-child(6)"), 0.3, {
        autoAlpha: 0.0,
        x: "60",
        ease: Power2.easeInOut
      });
    }
  });



  $(window).scroll(function() {
    $(".product_row").each(function() {
      var x_value_to_set;
      var bottom_of_object = $(this).offset().top;
      var bottom_of_window = $(window).scrollTop() + $(window).height();

      if ($(this).hasClass("product_row_0")) {
        x_value_to_set = "-1600";
      }

      if ($(this).hasClass("product_row_1")) {
        x_value_to_set = "1600";
      }

      if (bottom_of_window > bottom_of_object) {
        TweenMax.to($(this), 0.5, {
          autoAlpha: 1.0,
          x: 0,
        });
      } else {
        TweenMax.to($(this), 0.5, {
          autoAlpha: 0.0,
          x: x_value_to_set
        });
      }
    });
  });

  // View more button
  $(document).on("click", ".view_more_products_button", function() {
    $(".more_products_button_row").css("display", "none");
    $(".product_row").css("display", "block");
    goToByScroll(".product_row_2", 0, 0.5);
  });
}
// End event branding bits

// Single case study bits
if ($("body").hasClass("single-case_studies")) {
  // Scroll ins
  $(window).scroll(function() {
    $('.skills_used_item').each(function() {

      var x_value_to_set;
      var bottom_of_object = $(this).offset().top;
      var bottom_of_window = $(window).scrollTop() + $(window).height();

      if ($(this).hasClass("skills_used_box")) {
        x_value_to_set = "-1600";
      } else {
        x_value_to_set = "1600";
      }

      if (bottom_of_window > bottom_of_object) {
        TweenMax.to($(this), 0.5, {
          autoAlpha: 1.0,
          x: 0,
        });
      } else {
        TweenMax.to($(this), 0.5, {
          autoAlpha: 0.0,
          x: x_value_to_set
        });
      }
    });
  });
}
// End single case study bits

$(document).ready(function() {
  var carousel = $(".single_products_page_wrapper .owl-carousel");
  carousel.owlCarousel({
    loop: true,
    items: 2,
    nav: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      992: {
        items: 2,
        autoWidth: true
      }
    },
    navText: [$('.first_section_content .owl_prev_custom'), $('.first_section_content .owl_next_custom')]
  });
  checkClasses();
  carousel.on('translated.owl.carousel', function(event) {
    checkClasses();
  });
});

$(document).ready(function() {
  if ($.browser.mobile || result.innerHTML !== "You're not using Microsoft's Browser.") {
    // Do nothing for mobile
  } else {
    $('.how_can_we_help_you_banner').jarallax({
      speed: 0.5,
      imgWidth: 1366,
      imgHeight: 1000
    });
    $('.top_banner_wrapper:nth-child(2n) .banner_image').jarallax({
      speed: 0.5,
      imgWidth: 1366,
      imgHeight: 1000
    });
    $('.header .banner_image').jarallax({
      speed: 0.5,
      imgWidth: 1366,
      imgHeight: 1000
    });
  }
});

// Blog section
$(".recent_post_btn").on("click", function() {
  $(".recent_wrap").css("display", "block");
  TweenMax.to($(".recent_wrap"), 0.3, {
    autoAlpha: 1,
    y: "0",
    ease: Power1.easeInOut
  });
  $(".archive_wrap").css("display", "none");
  TweenMax.to($(".archive_wrap"), 0.3, {
    autoAlpha: 0,
    y: "-20",
    ease: Power1.easeInOut
  });
  $(".categories_wrap").css("display", "none");
  TweenMax.to($(".categories_wrap"), 0.3, {
    autoAlpha: 0,
    y: "-20",
    ease: Power1.easeInOut
  });
});

$(".archive_btn").on("click", function() {
  $(".archive_wrap").css("display", "block");
  TweenMax.to($(".archive_wrap"), 0.3, {
    autoAlpha: 1,
    y: "0",
    ease: Power1.easeInOut
  });
  $(".recent_wrap").css("display", "none");
  TweenMax.to($(".recent_wrap"), 0.3, {
    autoAlpha: 0,
    y: "-20",
    ease: Power1.easeInOut
  });
  $(".categories_wrap").css("display", "none");
  TweenMax.to($(".categories_wrap"), 0.3, {
    autoAlpha: 0,
    y: "-20",
    ease: Power1.easeInOut
  });
});

$(".categories_btn").on("click", function() {
  $(".categories_wrap").css("display", "block");
  TweenMax.to($(".categories_wrap"), 0.3, {
    autoAlpha: 1,
    y: "0",
    ease: Power1.easeInOut
  });
  $(".archive_wrap").css("display", "none");
  TweenMax.to($(".archive_wrap"), 0.3, {
    autoAlpha: 0,
    y: "-20",
    ease: Power1.easeInOut
  });
  $(".recent_wrap").css("display", "none");
  TweenMax.to($(".recent_wrap"), 0.3, {
    autoAlpha: 0,
    y: "-20",
    ease: Power1.easeInOut
  });
});



// Event Branding Back


if (window.location.href.indexOf("/?products_back=true") > -1) {
  console.log("in event branding");
  $(".more_products_button_row ").trigger("click");
   $(".product_row").css("display", "block");
   goToByScroll(".products_group", 0, 0.5);
}






// Search show hide

$(".search_wrapper").on("click", function() {
  $(".open").trigger("click");
  $(".search_it").css("display", "block");
  TweenMax.to($(".search_it"), 0.3, {
    autoAlpha: 1,
    y: "0",
    ease: Power1.easeInOut
  });
});

$(".close_btn").on("click", function() {
  $(".search_it").css("display", "none");
  TweenMax.to($(".search_it"), 0.3, {
    autoAlpha: 0,
    y: "-510px",
    ease: Power1.easeInOut
  });
});
